import { render, staticRenderFns } from "./bigdata.vue?vue&type=template&id=50a2faf6&scoped=true&"
import script from "./bigdata.vue?vue&type=script&lang=js&"
export * from "./bigdata.vue?vue&type=script&lang=js&"
import style0 from "./bigdata.vue?vue&type=style&index=0&id=50a2faf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a2faf6",
  null
  
)

export default component.exports